import httpManager from "@/app/shared/utils/httpManager";

/**
 * Obtener todos los canales.
 *
 * @param {number} channelId Identificador del canal.
 *
 * @return {Promise<ChannelCustomer[]>} Lista de canales.
 */
export default async function (channelId, portfolio, status = undefined, include_deleted = false) {
  let url = `/channels/channel-customer/?channel=${channelId}&portfolio=${portfolio ?? ""}`;
  if (status) url += `&status=${status}`;
  if (include_deleted) url += `&include_deleted=${include_deleted}`;
  const response = await httpManager.get(url);
  return response?.data;
}
